var React = require('react');

function ErinNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.375 2.3125L13.0625 13L2.375 23.6875","stroke":"#FCA301","strokeOpacity":"0.6","strokeWidth":"3.16667","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ErinNext.defaultProps = {"width":"15","height":"26","viewBox":"0 0 15 26","fill":"none"};

module.exports = ErinNext;

ErinNext.default = ErinNext;
